"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StateFilterDropdown;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function StateFilterDropdown(_ref) {
  var universes = _ref.universes,
      current = _ref.current,
      setUniverse = _ref.setUniverse,
      isLoading = _ref.isLoading;
  var options = universes.map(function (uni) {
    return {
      key: uni.universeId,
      text: uni.universeLabel,
      value: uni.universeId
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    className: "state-filter-dropdown",
    value: current,
    placeholder: "Data Set",
    options: options,
    direction: "left",
    loading: isLoading,
    onChange: function onChange(event, data) {
      setUniverse(data.value);
    }
  });
}